import React from 'react';
import DropzoneWrapper, { DropzoneRef, ExportedDropzoneWrapperProps } from '../../../modules/common/DropzoneWrapper';
import InternalDropzone from './Dropzone';
import {
  DropzoneProps,
  DropzoneValueProps as InternalDropzoneValueProps,
  DropzoneErrorEnum,
  DropzoneStateEnum,
} from './types';

export type DropzoneValueProps = ExportedDropzoneWrapperProps<DropzoneProps & InternalDropzoneValueProps>;

export type { DropzoneProps, DropzoneErrorEnum, DropzoneStateEnum };

const Dropzone = React.forwardRef<DropzoneRef, DropzoneValueProps>((props, ref) => (
  <DropzoneWrapper
    ref={ref}
    {...props}
    Content={InternalDropzone}
  />
));

export default Dropzone;
